module.exports = __webpack_public_path__ + "static/img/teacher.aaaeeb37.png";